import { Injectable } from '@angular/core';
import { EvidenceAndPreview, EvidenceFacade } from '@intrensic/evidence-management/data-access';
import { Observable, combineLatest, map } from 'rxjs';
import { LoggedInOfficer, OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { CaseDetails, CaseDetailsFacade } from '@intrensic/cases-management/data-access';
import { BaseResourceAvailabilityService } from '@shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class ResourceAvailabiltyService extends BaseResourceAvailabilityService {
  constructor(private evidenceFacade: EvidenceFacade, private officerDetailsFacade: OfficerDetailFacade, private caseDetailsFacade: CaseDetailsFacade) {
    super();
  }

  override isCaseInCurrentAgency(): Observable<boolean> {
    return combineLatest<[CaseDetails, LoggedInOfficer]>([this.caseDetailsFacade.getCaseDetails(), this.officerDetailsFacade.getLoggedInOfficer()]).pipe(
      map(([caseDetails, loggedInOfficer]) => caseDetails.agency.uid === loggedInOfficer.agencyUid)
    );
  }
  override isEvidenceInCurrentAgency(): Observable<boolean> {
    return combineLatest<[EvidenceAndPreview, LoggedInOfficer]>([this.evidenceFacade.getEvidence(), this.officerDetailsFacade.getLoggedInOfficer()]).pipe(
      map(([evidenceAndPreview, loggedInOfficer]) => evidenceAndPreview.evidence.agency.uid === loggedInOfficer.agencyUid)
    );
  }
  override isOfficerOrMemberInCurrentAgency(uid: string): Observable<boolean> {
    return this.officerDetailsFacade.getLoggedInOfficer().pipe(map((officer) => officer.agencyUid === uid));
  }
}
